import { EventProfileId } from "../../../services/event.service";
import { S25Util } from "../../../util/s25-util";
import { S25Assert } from "../../../util/s25.assert";

export namespace AddRemoveUtil {
    export type ContextId = `${number}|${number}` | `${number}` | number;

    export function extractEventProfileId(idString: ContextId): EventProfileId {
        const ids = ("" + idString).split("|");
        const event_id = S25Util.parseInt(ids[0]);
        const profile_id = S25Util.parseInt(ids[1]);
        if (profile_id) {
            return { event_id, profile_id };
        } else {
            return { event_id };
        }
    }

    export function extractAllEventAndProfileIds(ids: (ContextId | number)[]): {
        eventIds: number[];
        profileIds?: number[];
    } {
        const mapped = ids.map((id) => extractEventProfileId(id));
        const eventIds = mapped.map((id) => id.event_id);
        const profileIds = mapped.map((id) => id.profile_id).filter((id) => id !== undefined) as number[];
        S25Assert(
            profileIds.length === 0 || profileIds.length === eventIds.length,
            "Inconsistent ids: either all or none must have profile ids",
        );
        if (profileIds.length) {
            return { eventIds, profileIds };
        } else {
            return { eventIds };
        }
    }
}
